import request from '@/utils/request'

export function getSvipList(data_) {
    return request({
        url: '/api/svip_list',
        method: 'get',
        params: data_
    })
}
export function getAlbumProjectList(data_) {
    return request({
        url: '/api/vip/album_project_list',
        method: 'get',
        params: data_
    })
}
export function getBirthdayGiftBag(data) {
    return request({
        url: '/api/vip/birthday_gift_bag',
        method: 'post',
        data: data
    })
}
